module.exports = vendor_abdc350d12970d0fa6e5;